export function decodeJwt<T = Record<string, unknown>>(token: string): T | null {
    try {
        if (!token) return null
        const parts = token.split('.')
        if (parts.length < 2) return null
        const payload = parts[1]
        // base64 decode with padding fix
        const b64 = payload.replace(/-/g, '+').replace(/_/g, '/')
        const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4)
        const decoded = atob(padded)
        // handle potential unicode characters
        try {
            return JSON.parse(decodeURIComponent(escape(decoded))) as T
        } catch {
            // fallback if decodeURIComponent/escape fails
            return JSON.parse(decoded) as T
        }
    } catch {
        return null
    }
}

export function isTokenExpired(token: string | null | undefined): boolean {
    if (!token) return true
    const payload = decodeJwt<{ exp?: number }>(token)
    if (!payload || typeof payload.exp !== 'number') return true
    const now = Math.floor(Date.now() / 1000)
    return payload.exp <= now
}

export function getUserIdFromToken(token: string | null | undefined): string | null {
    if (!token) return null
    const payload = decodeJwt<{
        id?: string | number;
        userId?: string | number;
        user_id?: string | number;
        sub?: string | number;
        user?: { id?: string | number; userId?: string | number; user_id?: string | number };
    }>(token)

    const userId =
        payload?.userId ??
        payload?.user_id ??
        payload?.id ??
        payload?.user?.id ??
        payload?.user?.userId ??
        payload?.user?.user_id ??
        payload?.sub

    return userId != null ? String(userId) : null
}
